<div class="card bg-transparent border rounded-5 shadow-sm d-none d-xl-block mx-1">
    <h6 class="card-header text-muted bg-transparent mb-2 mt-2">Upcoming Events</h6>

  <div class="events-container">
    <div v-if="!loading && user_events.length === 0" class="empty-state">
      <!-- <i class="bx bx-calendar"></i> -->
      <p class="text-muted fst-italic small mb-0">You don't have any events</p>
    </div>

    <!-- Loading -->
    <div v-if="loading" class="text-center py-5 w-100">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2 mb-0 text-muted">Loading event...</p>
    </div>

    <!-- Events list (scrolls inside the tall card) -->
    <div class="flex-grow-1 overflow-auto">
      <div v-for="user_event in filteredEvents" :key="user_event.id" class="list-group list-group-flush">
        <div class="list-group-item border-0 p-2 bg-transparent pointer" @click="goToViewEvents">
          <div class="d-flex align-items-start gap-3">
            <div class="text-center bg-transparent rounded-3 px-2 py-1">
              <div class="fw-bold text-uppercase text-muted text-xxs">{{ formatDay(user_event.start_date) }}</div>
              <div class="fw-semibold text-muted text-xxs">{{ formatMonth(user_event.start_date) }}</div>
            </div>

            <div class="flex-grow-1 min-w-0">
              <h6 class="mb-1 fw-semibold small">{{ user_event.event_name }}</h6>
              <p class="mb-2 text-muted text-xxs">
                {{ formatDate(user_event.start_date) }},
                {{ user_event.start_time ? form_time(user_event.start_time) : "" }} –
                {{ user_event.end_time ? form_time(user_event.end_time) : "" }}
              </p>
            </div>

            <div v-if="!is_event_owner(user_event)" class="ms-auto flex-shrink-0 text-end" @click.stop>
              <button v-if="user_event.is_free && user_event.is_rsvped"
                      class="btn btn-sm btn-danger fw-semibold py-0 px-2 text-xxs"
                      @click="cancelRSVP(user_event.id)">
                Cancel RSVP
              </button>

              <button v-else-if="user_event.is_free && !countLimitedChapterRSVPs(user_event)"
                      class="btn btn-sm bg-primary text-white me-2 rounded shadow ms-2 text-xxs"
                      @click="selectEvent(user_event)"
                      >
                RSVP
              </button>
              <button v-else-if="!user_event.is_free && checkAvailableTickets(user_event)"
                      class="btn btn-sm bg-primary text-white me-2 rounded shadow ms-2 text-xxs"
                      @click="openModal(user_event)"
                      >
                Buy Ticket
              </button>
               <span v-else-if="!user_event.is_free && !checkAvailableTickets(user_event)" class="text-danger d-block small text-xxs">
                No available tickets
              </span>

              <span v-else-if="user_event.is_free" class="text-danger d-block small text-xxs">
                RSVP has reached its limit
              </span>
            </div>
          </div>
        </div>
        <div class="border-bottom"></div>
      </div>
    </div>

    <!-- See more / less pinned to bottom -->
    <div v-if="user_events.length > visibleCount" class="mt-auto pt-2 text-center mt-3 cursor-pointer">
      <a class="text-decoration-none fs-italic text-xxs" @click="toggleShowMore">
        {{ showAll ? "See Less" : "See More" }}
      </a>
    </div>
  </div>
</div>



<teleport to="body">
<div class="modal fade" id="event_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-5 border-0 shadow-sm">
      <div class="modal-header border-0">
        <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body modal-body-scroll d-flex flex-column align-items-center text-center">

        <img src="@/assets/images/thank-you.png" class="w-150" alt="">
        <h6 class="text-center">Thank you for registering</h6>
        <p class="text-center">Please confirm your RSVP below</p>

        <!-- JOIN LINK FOR ONLINE EVENTS -->
        <div v-if="(selectedEvent?.event_type?.name === 'online' ) && selectedEvent?.event_link">
          <a v-if="isEventStarted(selectedEvent).canJoin"
             :class="['btn', 'btn-sm', 'fw-500', 'me-2', 'btn-primary']"
             :href="selectedEvent?.event_link">
            Join Event
          </a>
          <p v-else class="text-muted text-sm mt-1">
            {{ isEventStarted(selectedEvent).message }}
          </p>
        </div>

        <!-- RSVP / CANCEL LOGIC -->
        <div v-if="selectedEvent?.event_type?.name !== 'online' ">
          <span v-if="!isWithinRSVPPeriod(selectedEvent)?.isValid" class="d-inline-block">
            <button :class="[
                      'btn',
                      'btn-sm',
                      'fw-500',
                      selectedEvent?.is_rsvped ? 'btn-warning' : 'btn-primary'
                    ]" disabled style="pointer-events: none;">
              {{ selectedEvent?.is_rsvped ? 'RSVP’d' : 'Confirm RSVP' }}
            </button>
            <p class="text-danger text-xs">{{ isWithinRSVPPeriod(selectedEvent)?.message }}</p>
          </span>

          <button v-else class="gap-3" :class="[
                    'btn',
                    'btn-sm',
                    'fw-500',
                    'me-2',
                    selectedEvent?.is_rsvped ? 'btn-warning' : 'btn-primary'
                  ]" @click="fetchEvents_extras(selectedEvent.id)">
            {{ selectedEvent?.is_rsvped ? 'RSVP’d' : 'Confirm RSVP' }}
          </button>
        </div>

      </div>
    </div>
  </div>
</div>
</teleport>


<teleport to="body">
  <div class="modal fade" id="rsvp_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content border-0 shadow rounded-3 bg-light">

           <div class="modal-header bg-primary d-flex align-items-center">
              <i class="bi bi-ticket-perforated-fill text-white fs-4 me-2"></i> <!-- me-2 adds right margin -->
              <h5 class="modal-title fw-bold mb-0 fs-5 text-white" id="exampleModalLabel">RSVP</h5>
              <button type="button" class="btn-close bg-light" data-bs-dismiss="modal"></button>
          </div>


            <form @submit.prevent="addRsvp">
                <div class="modal-body overflow-auto modal-scroll" >

                    <!-- Business Name -->
                    <div v-if="cbo_domain" class="mb-3">
                        <label for="businessName" class="form-label fw-semibold small text-secondary">Provide business name</label>
                        <input type="text" v-model="businessName" placeholder="Business Name" class="form-control rounded">
                    </div>

                    <!-- First Time Attending -->
                    <div v-if="cbo_domain" class="mb-3">
                        <label for="firstTimeSelect" class="form-label fw-semibold small text-secondary">Is this your first time attending?</label>
                        <select v-model="isFirstTime" class="form-select rounded" id="firstTimeSelect">
                            <option disabled value="">Please select an option</option>
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                        </select>
                    </div>

                    <!-- Home Chapter -->
                    <div v-if="cbo_domain" class="mb-4">
                        <label for="chapterSelect" class="form-label fw-semibold small text-secondary">Home Chapter</label>
                        <select v-model="chapter" class="form-select rounded" id="chapterSelect">
                            <option disabled value="">Please select a chapter</option>
                            <option v-for="chapter in chapters" :key="chapter" :value="chapter">{{ chapter }}</option>
                        </select>
                    </div>

                    <!-- Divider before extras -->
                    <div v-if="eventExtras.length > 0" class="border-top mb-4 pt-4"></div>

                    <!-- Menu Selection -->
                                          <!-- Menu Selection -->
                    <div v-for="extra in eventExtras" :key="extra.id" class="mb-4">
                      <div class="d-flex align-items-center gap-2 mb-3">
                          <i class="bi bi-star text-secondary fs-6"></i> 
                          <label class="form-label text-uppercase fw-bold mb-0 small text-primary">{{ extra.extra.name }}</label>
                      </div>

                      <div class="d-flex flex-column gap-2">
                          <div v-for="item in extra.items" :key="item.id"
                              class="border rounded p-3 d-flex align-items-center gap-3 cursor-pointer transition-all"
                              :class="{
                                  'border-primary bg-light shadow-sm': selectedItemId.includes(item.id),
                                  'bg-white': !selectedItemId.includes(item.id)
                              }"
                              @click="toggleItem(item.id)">

                              <input class="form-check-input mt-0 me-3" 
                                  type="checkbox"
                                  :id="'item_' + item.id"
                                  :value="item.id"
                                  v-model="selectedItemId" 
                                  @click.stop="toggleItem(item.id)"> <div class="flex-grow-1 d-flex justify-content-between align-items-center">
                                  <div>
                                      <div class="fw-semibold">{{ item.item_name }}</div>
                                      <div class="text-muted small">{{ item.description }}</div>
                                  </div>
                                  <div v-if="!workbook_domain" class="fw-bold text-primary small">R{{ item.price }}</div>
                              </div>
                          </div>
                      </div>
                  </div>

                    <!-- Validation Message -->
                    <div v-if="formError" class="alert alert-danger mt-3 py-2 px-3 small">
                        <strong>⚠️</strong> Please select at least one item to RSVP.
                    </div>

                    <!-- Dietary Restrictions (hidden) -->
                    <div class="mb-3 d-none">
                        <label class="form-label fw-semibold small">Additional Restrictions</label>
                        <textarea class="form-control rounded" rows="2" placeholder="Please specify any allergies or restrictions" v-model="dietaryRestrictions"></textarea>
                    </div>
                </div>

                <div class="modal-footer border-top py-3 bg-light">
                    <button type="submit" class="btn btn-primary text-xxs rounded" :disabled="!selectedItemId.length">Submit</button>
                    
                </div>
            </form>

        </div>
    </div>
</div>
</teleport>

  <teleport to="body">
    <div class="modal fade" id="user_ticket_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content rounded border-0 shadow-sm">

      <!-- HEADER -->
      <div class="modal-header bg-primary text-white position-relative">
        <p class="modal-title text-xxs fw-500">{{ selectedEvent?.event_name }}</p>
        <button
          type="button"
          class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>

      <!-- BODY -->
      <div class="modal-body">

        <!-- Event Info -->
        <div class="text-start mb-3">
          <p class="mb-1 text-muted">
            <i class="bi bi-calendar-event"></i>
            {{ formatDate(selectedEvent?.start_date) }}
          </p>
          <p class="mb-1 text-muted" v-if="selectedEvent?.location">
            <i class="bi bi-geo-alt"></i>
            {{ selectedEvent.location }}
          </p>
          <span class="badge bg-light text-dark border rounded-pill" v-if="!selectedEvent?.is_free">
            Paid Event
          </span>
        </div>
        

        <!-- Tickets Section -->
        <p class="">Select Tickets</p>
        <div v-for="ticket in selectedEvent.event_tickets" :key="ticket.id"
          class="d-flex justify-content-between align-items-center border-0 shadow-sm bg-light p-2 mb-2">

        <!-- Ticket Info -->
        <div class="text-start">
          <div class="fw-500">
            {{ ticket?.ticket?.name }}
           <span v-if="ticket.is_sold_out" class="badge bg-danger ms-2">Sold Out</span>
          </div>
          <div class="text-success fw-bold">
            R{{ ticket?.price }}
          </div>
    <small class="text-muted" v-if="ticket.available_instances > 0">
      Available: {{ ticket.available_instances }}
    </small>
        </div>

        <!-- Counter -->
        <div class="d-inline-flex align-items-center border rounded px-2">
          <button class="btn btn-sm border-0 shadow-0 px-2"
                  @click="ticket.quantitySelected = Math.max(0, ticket.quantitySelected - 1)">
            –
          </button>
          <span class="px-3">{{ ticket?.quantitySelected }}</span>
          <button class="btn btn-sm border-0 shadow-0 px-2"
                  @click="ticket.quantitySelected = Math.min(ticket.available_instances, ticket.quantitySelected + 1)">
            +
          </button>
        </div>
      </div>


      </div>

      <!-- FOOTER -->
      <div class="modal-footer d-flex justify-content-between align-items-center border-0">
        <h6 class="fw-bold mb-0">Total: R{{ event_tickets.reduce((sum, t) => sum + (t.quantitySelected * t.price), 0) }}</h6>
        <button class="btn btn-primary rounded btn-sm px-4" @click="process_to_checkout"> Proceed To Checkout</button>
      </div>

    </div>
  </div>
</div>
  </teleport>

